import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfiguracionDialogoAccion } from './utilidades/dialogo-accion.static';

@Component({
  selector: 'dialogos-accion',
  templateUrl: './dialogo-accion.component.html',
  styleUrls: ['./dialogo-accion.component.scss'],
  standalone: false,
})
export class DialogoAccionComponent implements AfterViewInit {
  @ViewChild('mensaje') mensaje!: ElementRef;

  constructor(
    protected readonly dialogRef: MatDialogRef<DialogoAccionComponent>,
    @Inject(MAT_DIALOG_DATA)
    protected readonly configuracion: ConfiguracionDialogoAccion,
  ) {}

  ngAfterViewInit(): void {
    this.mensaje.nativeElement.innerHTML = this.configuracion.mensaje;
  }
}
